import './ClubOneLogin.scss'

import { ClubOneCardIcon } from '@tallink/components-lib'
import classNames from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isSsoDisabled, isSsoErrorOccurred } from '../../../../../selectors/selectors'
import ClubOneSsoLoginLink from '../../../../common/ClubOneSsoLoginLink'
import ClubOneHint from '../ClubOneHint/ClubOneHint'
import ErrorTooltip from '../ErrorTooltip/ErrorTooltip'

export default function ClubOneLogin() {
  const [width, setWidth] = useState(0)
  const { t } = useTranslation()
  const ssoDisabled = useSelector(isSsoDisabled)
  const ssoError = useSelector(isSsoErrorOccurred)

  return (
    <>
      <section
        className={classNames('club-one-login', { disabled: ssoDisabled })}
        ref={el => {
          if (!el) return
          setWidth(el.offsetWidth)
        }}
      >
        <ClubOneCardIcon className="icon" level="NONE" />
        <ClubOneSsoLoginLink />
        <ClubOneHint containerWidth={width} hintText={t('hint.clubOne.text')} />
      </section>
      {ssoError && <ErrorTooltip />}
    </>
  )
}
